import axios from 'axios'

// Configure axios defaults
axios.defaults.withCredentials = true

// When running locally, point to backend server
if (window.location.hostname === 'localhost') {
  axios.defaults.baseURL = 'http://localhost:3001'
}

// Add request interceptor for debugging
axios.interceptors.request.use(
  (config) => {
    console.log('Making request to:', config.url)
    return config
  },
  (error) => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// Add response interceptor for debugging
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.error('Response error:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

export default axios 